import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import axios from 'axios';
import { useWeb3React } from '@web3-react/core';
import ConnectButton from '../../components/ConnectButton';
import RainbowBalancePanel from '../../components/RainbowBalancePanel';
import YourCollectionPanelNew from '../../components/YourCollectionPanelNew';
import WallpaperPanel from '../../components/WallpaperPanel';
import SocialPanel from '../../components/SocialPanel';

import styles from '../../styles/Stake.module.scss';
import { Spinner } from 'react-bootstrap';

const Stake = () => {
  const { active } = useWeb3React();
  const [synced, setSynced] = useState(false);
  const [enableWithdrawals, setEnableWithdrawals] = useState(false);
  const router = useRouter();

  useEffect(() => {
    Promise.all([
      axios.post('/api/sync'),
      axios.post('/api/sync/withdrawals'),
    ]).finally(() => {
      setSynced(true);
    });
  }, []);

  useEffect(() => {
    const enableWithdrawals =
      process.env.NEXT_PUBLIC_ENABLE_WITHDRAWALS === 'true' ||
      router.query.withdrawals === 'true';
    setEnableWithdrawals(enableWithdrawals);
  }, [router]);

  if (!active) {
    return (
      <div className="blue-gradient">
        <div className="container py-5 text-center">
          <p className="lead">Please connect your wallet</p>
          <ConnectButton />
        </div>
      </div>
    );
  }

  return (
    <>
      <Head>
        <title>Dashboard | Noundles</title>
      </Head>

      <div className="blue-gradient">
        <div className={styles.rainbow}>
          <div className="container py-5">
            <div className="py-3">
              <div className={styles.card}>
                <YourCollectionPanelNew />
              </div>
            </div>
            <div className="py-3">
              <div className={styles.card}>
                <RainbowBalancePanel enableWithdrawals={enableWithdrawals} />
              </div>
            </div>
            <div className="py-3">
              <div className={styles.card}>
                <SocialPanel />
              </div>
            </div>
            <div className="py-3">
              <div className={styles.card}>
                <WallpaperPanel />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stake;
